import React from "react";
import { Avatar } from "./Avatar";
import { cx } from "../../utils/cx";

export function AvatarStack({ actors, overlapClass = "-ml-6" }) {
  const max = 3;
  const shown = (actors || []).slice(0, max);
  const overflow = Math.max((actors || []).length - max, 0);
  return (
    <div className="relative h-10 flex items-center">
      <div className="flex items-center">
        {overflow > 0 && (
          <div className="h-8 w-8 rounded-full bg-surface-muted text-text-secondary flex items-center justify-center text-xs font-semibold ring-2 ring-border-light z-0">
            +{overflow}
          </div>
        )}
        {shown.map((a, i) => (
          <div
            key={i}
            className={cx(
              "h-8 w-8 rounded-full flex items-center justify-center ring-2 ring-border-light overflow-hidden z-10",
              i ? overlapClass : overflow > 0 ? overlapClass : ""
            )}
          >
            <Avatar name={a.name} avatarUrl={a.avatarUrl} />
          </div>
        ))}
      </div>
    </div>
  );
}
